'use strict';
var twentyninetimes = twentyninetimes || {};

twentyninetimes.feedback = twentyninetimes.feedback || function () {

	function init() {
		var feedback_container = document.getElementById('single-feedback');
		if ( feedback_container ) {
			feedback_counter(feedback_container);
			feedback_comment(feedback_container);
		}
	}

	function feedback_counter(feedback_container) {
		feedback_container.addEventListener('click', (e) => {
		    var target = e.target,
		        trigger = target.closest('.feedback-trigger');

		    if ( feedback_container.classList.contains('disabled') ) return;
		    if ( !trigger ) return;
		    
		    var trigger_value   = trigger.getAttribute('data-value'),
		        trigger_post    = trigger.getAttribute('data-post');

		    feedback_container.classList.add('disabled');
		    trigger.classList.add('highlight');

		    // Update post feedback counter
		    var action 		= 'post_feedback_counter',
		    	send_url 	= 'action='+action+'&value='+trigger_value+'&post='+trigger_post;
		    post_feedback_ajax(send_url);

		    // Set feedback cookie for the specific post
		    feedback_cookie(trigger_value, trigger_post);

		    if ( trigger_value == 'good' ) {
		    	feedback_text(feedback_container);
		    } else {
		    	if ( !feedback_container.classList.contains('comment-open') ) {
			    	var comment = feedback_container.querySelector('.js-feedback-comment .customform-container');

			    	comment.style.height = 'auto';
			    	var commentHeight = comment.clientHeight;
			    	comment.style.height = '0px';

			    	setTimeout(function () {
			    		feedback_container.classList.add('comment-open');
			    		comment.style.height = commentHeight + 'px';

			    		setTimeout(function () {
			    			if ( feedback_container.classList.contains('comment-open') ) {
			    				comment.style.height = 'auto';
			    			}
			    		}, 600);
			    	}, 10);
		    	}
		    }
		});
	}

	function feedback_comment(feedback_container) {
		var feedback_form = feedback_container.querySelector('.js-feedback-form');

		if ( feedback_form ) {
			feedback_form.addEventListener('submit', (e) => {
				e.preventDefault();

				/*** HONEY POT START ***/
				var hp_firstname = feedback_form.querySelector('input[name="fb-firstname"]'),
					hp_lastname = feedback_form.querySelector('input[name="fb-lastname"]');

				if ( +hp_firstname.value + +hp_lastname.value != 29 ) return;
				/*** HONEY POT END ***/

				var textarea = feedback_form.querySelector('textarea'),
					comment = feedback_container.querySelector('.js-feedback-comment .customform-container'),
					comment_value = textarea.value,
					post = feedback_form.getAttribute('data-post');

				if ( comment_value == '' ) return;

				// Add feedback comment to post via ajax
				var action 		= 'post_feedback_comment',
					send_url 	= 'action='+action+'&comment='+comment_value+'&post='+post;
				post_feedback_ajax(send_url);

				/*** CLOSE COMMENT START ***/
				comment.style.height = comment.clientHeight+'px';
				
				setTimeout(function () {
					if ( feedback_container.classList.contains('comment-open') )
						feedback_container.classList.remove('comment-open');

					comment.style.height = '0px';
				}, 10);

				setTimeout(function () {
					feedback_text(feedback_container);

					feedback_form.parentNode.removeChild(feedback_form);
				}, 610);
				/*** CLOSE COMMENT END ***/
			});
		}
	}

	function post_feedback_ajax(send_url) {
		// https://getbutterfly.com/how-to-replace-jquery-ajax-with-vanilla-javascript-in-wordpress/
		var xhr     = new XMLHttpRequest(),
		    method  = 'POST',
		    url     = load_more_params.ajaxurl;

		xhr.open(method, url, true);
		xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;');
		xhr.send(send_url);

		xhr.onload = function() {
		    if (xhr.status >= 200 && xhr.status < 400) {
		        // If successful
		        let response = JSON.parse(xhr.responseText);

		        console.log(response);
		    } else {
		        // If fail
		        console.log(xhr.response);
		    }
		};

		xhr.onerror = function() {
		    alert("Something went wrong... Please try again later");
		};
	}

	function feedback_cookie(value, post) {
		var cookie_name 	= 'feedback_post_'+post,
			cookie_value 	= value,
			cookie_expiry 	= 365;

		let feedback_cookie = getCookie(cookie_name);

		if ( !feedback_cookie ) 
			setCookie(cookie_name, cookie_value, cookie_expiry);
	}

	function feedback_text(container) {
		var feedback_text = document.createElement('SPAN');
		feedback_text.setAttribute('class', 'single-feedback__text');
		feedback_text.innerHTML = 'Tak for din feedback!';

		container.appendChild(feedback_text);
	}

	return {
		init : init
	};

}();

function setCookie(cname, cvalue, exdays) {
	var d = new Date();
	d.setTime(d.getTime() + (exdays*24*60*60*1000));
	var expires = "expireDays="+ d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}